module.exports = __webpack_public_path__ + "static/media/vkdonut_bg.ceb52b8e.png";